module.exports = __webpack_public_path__ + "KaTeX_Main-BoldItalic.4b560bdf.ttf";